import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { CustomerBillingCustomerModel } from '@fi-app/customer-billing/customer-billing-customer/customer-billing-customer.model';
import { BillingContactModel } from '@fi-app/billing/billing-contact.model';

@Component({
    selector: 'fi-customer-billing-customer-edit-credit-card-information',
    templateUrl: './customer-billing-customer-edit-credit-card-information.component.html',
    styleUrls: ['./customer-billing-customer-edit-credit-card-information.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-customer-billing-customer-edit-credit-card-information' },
    standalone: false,
})
export class CustomerBillingCustomerEditCreditCardInformationComponent {
    @Input() customer: CustomerBillingCustomerModel;
    @Input() ccBillingReference: BillingContactModel;
}
